import Swiper from "swiper";
/* 
Swiper属性记录：

// 设置slider容器能够同时显示的slides数量
slidesPerView: 5,
// 是否循环播放，默认为false，可设置为true
loop: true,
// 是否启用自由模式功能，默认为false，可设置为true
freeMode: true, 
// 在 loop 模式下使用，该参数设置所要用到的loop 个数
loopedSlides: 5, 
// 会在每个可见slide增加一个类名（swiper-slide-visible）
watchSlidesVisibility: true, 
// 配合 watchSlidesVisibility 使用的
watchSlidesProgress: true, 






*/

/**
 *
 * @desc 轮播图
 *
 */
const swiperFn = {
  /**
   *
   * @desc 公共轮播（无任何默认效果）
   * @example common('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   *
   */
  common: (domName, param) => {
    if (!domName) return;
    if (!param) return;
    return new Swiper(domName, param);
  },
  /**
   *
   * @desc 无缝轮播（默认自动播放）
   * @example seamless('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   *
   */
  seamless: (domName, param) => {
    if (!domName) return;
    param = Object.assign(
      {
        loop: true,
        // 在slide之间设置距离（单位px）
        spaceBetween: 15,
        slidesPerView: "auto",
        slidesPerGroup: 1,
        // 是否启用自由模式功能，默认为false，可设置为true
        freeMode: true,
        // 速度
        speed: 5000,
        // 用户操作swiper之后，是否禁止autoplay
        autoplayDisableOnInteraction: false,
        //如果需要自动切换海报
        autoplay: {
          //时间 毫秒
          delay: 0,
          //用户操作之后是否停止自动轮播默认true
          disableOnInteraction: false,
        },
      },
      param
    );
    return new Swiper(domName, param);
  },
  /**
   *
   * @desc 异形轮播(默认自动播放)
   * @example alien('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   *
   */
  alien: (domName, param) => {
    if (!domName) return;
    param = Object.assign(
      {
        slidesPerView: 1.4,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination2",
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
      param
    );
    return new Swiper(domName, param);
  },
  /**
   *
   * @desc 缩略图轮播(默认自动播放),注意缩略图类名默认为：thumbnail-thumbs
   * @example thumbnail.main('.swiper',{thumbs: {this.$swiper.thumbnail.thumb('.thumbnail-thumbs')}})
   * @param domName dom元素
   * @param param 配置数据
   *
   */
  thumbnail: {
    thumb: (domName, param) => {
      if (!domName) return;
      param = Object.assign(
        {
          // 设置slider容器能够同时显示的slides数量
          slidesPerView: 5.8, // 调整为4.2，确保有足够的可视空间
          slidesOffsetAfter: 20, // 最后一个幻灯片后的间距，与 padding-right 一致
          // 每次滑动的slide数量
          slidesPerGroup: 1,
          // slide之间的间距，与CSS中的margin-right保持一致
          spaceBetween: 10,
          // 是否循环播放，默认为false，可设置为true
          // loop: true,
          // 启用自由模式，让滑动更加灵活
          freeMode: true,
          // 自由模式下的惯性
          freeModeMomentum: true,
          // 自由模式下的惯性比例
          freeModeMomentumRatio: 0.5,
          // 自由模式下的最小速度
          freeModeMinimumVelocity: 0.1,
          // 在 loop 模式下使用，该参数设置所要用到的loop 个数
          loopedSlides: 5,
          // 会在每个可见slide增加一个类名（swiper-slide-visible）
          watchSlidesVisibility: true,
          // 配合 watchSlidesVisibility 使用的
          watchSlidesProgress: true,
          // 点击slide时滑动到该slide
          slideToClickedSlide: true,
          // 确保边界处理
          resistanceRatio: 0.85,
          // 边界反弹
          bounceEffect: true,
        },
        param
      );
      const swiper = new Swiper(domName, param);

      swiper.on("click", function () {
        const clickedIndex = this.clickedIndex;
        const activeIndex = this.activeIndex;
        if (clickedIndex > activeIndex) {
          this.slideNext();
        } else if (clickedIndex < activeIndex) {
          this.slidePrev();
        }
      });

      return swiper;
    },
    /* 主轮播 */
    main: (domName, param) => {
      if (!domName) {
        return;
      }
      param = Object.assign(
        {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            // 自定义分页渲染，限制显示 3 个圆点
          },
          // 设置slider容器能够同时显示的slides数量
          slidesPerView: "auto",
          // 是否循环播放，默认为false，可设置为true。
          loop: true,
          // 在 loop 模式下使用，该参数设置所要用到的loop 个数
          loopedSlides: 5,
          // 是否自动播放，默认为false，可设置为true。
          autoplay: {
            // 自动切换的时间间隔
            delay: 4000,
            // 用户操作swiper之后，是否禁止autoplay。默认为true：停止
            disableOnInteraction: false,
          },
          // thumbs组件用于制作带缩略图的swiper
          thumbs: {
            swiper: swiperFn.thumbnail.thumb(".thumbnail-thumbs"),
          },
        },
        param
      );
      return new Swiper(domName, param);
    },
  },
  /**
   *
   * @desc 卡片化轮播(默认自动播放)
   * @example cardBased('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   *
   */
  cardBased: (domName, param) => {
    if (!domName) return;
    param = Object.assign(
      {
        // 滑动方向，可设置水平(horizontal)或垂直(vertical)。
        direction: "horizontal",
        // 设置为true 则开启loop模式  衔接滑动
        loop: true,
        // 自动滑动
        autoplay: {
          delay: 3000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换。
          stopOnLastSlide: false,
          // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
          disableOnInteraction: false,
        },
        // 切换效果 "coverflow"（3d流）
        effect: "coverflow",
        // 设置slider容器能够同时显示的slides数量(carousel模式)。类型：number or auto
        slidesPerView: "auto",
        // 设定为true时，active slide会居中，而不是默认状态下的居左。
        centeredSlides: true,
        // 在slide之间设置距离（单位px）。
        spaceBetween: -150,
        // 设置为true则点击slide会过渡到这个slide。
        slideToClickedSlide: true,
        // loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。
        // loopAdditionaSlider: 0,
        coverflowEffect: {
          // slide做3d旋转时Y轴的旋转角度
          rotate: 0,
          // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
          stretch: 0,
          // slide的位置深度。值越大z轴距离越远，看起来越小。
          depth: 70,
          // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
          modifier: 10,
          // 是否开启slide阴影
          slideShadows: true,
        },
      },
      param
    );
    return new Swiper(domName, param);
  },
  /**
   *
   * @desc 无缝滚动纵向(默认自动播放)
   * @example longitudinal('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   *
   */
  longitudinal: (domName, param) => {
    if (!domName) return;
    param = Object.assign(
      {
        loop: true,
        slidesPerView: "auto",
        direction: "vertical",
        speed: 5000,
        // 用户操作swiper之后，是否禁止autoplay
        autoplayDisableOnInteraction: false,
        // // 如果需要自动切换海报
        autoplay: {
          //时间 毫秒
          delay: 0,
          //用户操作之后是否停止自动轮播默认true
          disableOnInteraction: false,
        },
      },
      param
    );
    return new Swiper(domName, param);
  },
};
export default {
  ...swiperFn,
};
